export const SCHEDULE_FORM_UPDATE = 'SCHEDULE_FORM_UPDATE';
export const SCHEDULE_FORM_UPDATE_TIME_SLOT = 'SCHEDULE_FORM_UPDATE_TIME_SLOT';
export const SCHEDULE_FORM_UPDATE_REMOVE_TIME_SLOT = 'SCHEDULE_FORM_UPDATE_REMOVE_TIME_SLOT';
export const SCHEDULE_FORM_UPDATE_ADD_TIME_SLOT = 'SCHEDULE_FORM_UPDATE_ADD_TIME_SLOT';
export const SCHEDULE_FORM_SET_SCHEDULE = 'SCHEDULE_FORM_SET_SCHEDULE';
export const SCHEDULE_FORM_RESET = 'SCHEDULE_FORM_RESET';

export const updateScheduleForm = (e) => ({
  type: SCHEDULE_FORM_UPDATE,
  payload: {
    [e.target.name]: e.target.value
  },
});

export const updateTimeSlot = (day, time, field, value) => ({
  type: SCHEDULE_FORM_UPDATE_TIME_SLOT,
  day: day,
  time: time,
  payload: {
    [field]: value
  },
});

export const removeTimeSlot = (day, time) => ({
  type: SCHEDULE_FORM_UPDATE_REMOVE_TIME_SLOT,
  day,
  time,
});

export const addTimeSlot = (day, time, low, high) => ({
  type: SCHEDULE_FORM_UPDATE_ADD_TIME_SLOT,
  day,
  time,
  low,
  high,
});

export const setSchedule = (schedule) => ({
  type: SCHEDULE_FORM_SET_SCHEDULE,
  schedule,
});

export const resetScheduleForm = () => ({
  type: SCHEDULE_FORM_RESET,
});



// WEBPACK FOOTER //
// ./src/actions/scheduleForm.js